import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
} from 'react-bootstrap';

import OperatorFormEnhanced from '../containers/OperatorFormEnhanced';

const propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types, react/require-default-props */
  initialValues: PropTypes.object,
  /* eslint-enable react/forbid-prop-types, react/require-default-props */
};


const OperatorEditModal = (props) => {
  const {
    show, onHide, initialValues,
  } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Operator</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <OperatorFormEnhanced
          isAddingOperator={false}
          initialValues={initialValues}
          onHide={onHide}
          joinType="lookup_records"
          lookupStatus="reference"
        />
      </Modal.Body>
    </Modal>
  );
};

OperatorEditModal.propTypes = propTypes;

export default OperatorEditModal;
